module.exports = __webpack_public_path__ + "img/Corona.7af8ee78.png";